const baseUrls = process.env.REACT_APP_BASE_URLS?.split(',') || [];

export const getRoundRobinBaseUrl = () => {
  if (baseUrls.length === 0) return '';

  let index = parseInt(localStorage.getItem('loadBalanceIndex') || '0', 10);
  const selectedUrl = baseUrls[index];

  // Update index for next request
  index = (index + 1) % baseUrls.length;
  localStorage.setItem('loadBalanceIndex', index.toString());

  return selectedUrl;
};
